import { Clock, AlertTriangle } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useCompany } from "@/context/CompanyContext";
import { useDepot } from "@/context/DepotContext";
import { openBilling, fmtDay } from "@/lib/plans";

// Slim strip under the header: trial countdown, failed payment or a plan that's ending.
export const TrialBanner = () => {
  const { user } = useAuth();
  const { company } = useCompany();
  const { isAdmin } = useDepot();
  const b = company?.billing;
  if (user?.role !== "coordinator" || !b) return null;
  let tone = "bg-secondary text-foreground", text = "", cta = "Manage plan";
  if (b.status === "trial") {
    tone = b.ending_soon ? "bg-amber-500/15 text-amber-900 dark:text-amber-200" : "bg-secondary text-foreground";
    text = `Free trial: ${b.days_left} day${b.days_left === 1 ? "" : "s"} left.`;
    cta = "Pick a plan";
  } else if (b.status === "past_due") {
    tone = "bg-destructive/10 text-destructive";
    text = "Your last card payment didn't go through. Update your card to keep the office dashboard open.";
    cta = "Update card";
  } else if (b.cancel_date) {
    tone = "bg-amber-500/15 text-amber-900 dark:text-amber-200";
    text = `Your ${b.plan_name} plan ends on ${fmtDay(b.cancel_date)}.`;
  } else return null;
  const Icon = b.status === "trial" ? Clock : AlertTriangle;
  return (
    <div className={tone} data-testid="billing-banner">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-1.5 flex items-center gap-2 text-xs sm:text-sm">
        <Icon className="w-4 h-4 shrink-0" />
        <span data-testid="billing-banner-text">{text}{!isAdmin && b.status === "trial" ? " Your company login can pick a plan." : ""}</span>
        {isAdmin && (
          <button onClick={() => openBilling()} data-testid="billing-banner-btn"
            className="ml-auto shrink-0 rounded-full bg-primary text-white px-3 py-1 text-xs font-bold hover:bg-primary/90 transition-colors">{cta}</button>
        )}
      </div>
    </div>
  );
};
